import { useSelector } from 'react-redux'

import { CollectionUUID } from '@library/menu-service'

import { getCurrentCollectionId } from 'selectors/menu-collections/getCurrentCollectionId'

export const useCurrentCollectionId = (): CollectionUUID | null =>
  useSelector(getCurrentCollectionId)
